@if ({ hideTeams: hideTeams$ | async }; as state) {
  @if (
    group.isLoaded &&
    group.type === SelectionListType.SINGLE_GROUP &&
    (!state.hideTeams || !group.isTeams)
  ) {
    <app-basic-user-selection-list-group
      (user)="handleUser($event)"
      [users]="group.data"
      (usersChange)="handleChange($event)"
      [multiple]="multiple"
      [hideLabels]="hideLabels"
      [label]="group.selectAllControlName || group.name"
    >
    </app-basic-user-selection-list-group>
  }
  @if (group.isLoaded && group.type === SelectionListType.SUBGROUPED) {
    @for (subgroup of group.data; track subgroupTrackBy($index, subgroup)) {
      @if (!state.hideTeams || !subgroup.isTeams) {
        <app-basic-user-selection-list-group
          (user)="handleUser($event)"
          [users]="subgroup.data"
          (usersChange)="handleChange($event)"
          [multiple]="multiple"
          [hideLabels]="hideLabels"
          [label]="subgroup.selectAllControlName || subgroup.name"
        >
        </app-basic-user-selection-list-group>
      }
    }
  }
  @if (group.isLoaded && !group.data?.length) {
    <div class="mat-body">No results</div>
  }
}

@if (!group.isLoaded) {
  <app-basic-spinner class="spinner" diameter="15"></app-basic-spinner>
}
